module.exports = __webpack_public_path__ + "static/media/bcel-commerce.664bb004.png";